export const DomainType = {
  Facility: "Facility",
  Practice: "Practice",
} as const;

export type DomainTypeEnum = (typeof DomainType)[keyof typeof DomainType];
